import PropTypes from 'prop-types';
import ContentPanel from 'components/ui-components/ContentPanel';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import AddressLines from 'components/ui-components/AddressLines';
import HookFormPostcodeSelector from 'components/cef_form/hook-form/HookFormPostcodeSelector';

const RegisteredAddressSelector = ({
  companyNumberLookupSuccess,
  companiesHouseAddress,
  postcodeSearched,
  setPostcodeSearched,
  setPostcodeIsReset,
  manualCompanyAddressDataModel,
  persistedData,
}) => (
  <InnerFormSection title="Registered Office Address">
    {companyNumberLookupSuccess && companiesHouseAddress ? (
      // Show data fetched from Companies House
      <ContentPanel className="mt-10">
        <p className="mb-0 fs-16 tc-secondary fw-400">
          <AddressLines address={companiesHouseAddress} />
        </p>
      </ContentPanel>
    ) : (
      // Show manual entry postcode selector
      <HookFormPostcodeSelector
        className="mt-20"
        id="manualCompany"
        postcodeSearched={postcodeSearched}
        setPostcodeSearched={setPostcodeSearched}
        setPostcodeIsReset={setPostcodeIsReset}
        addressDataModel={manualCompanyAddressDataModel}
        persistedData={persistedData}
      />
    )}
  </InnerFormSection>
);

RegisteredAddressSelector.propTypes = {
  companyNumberLookupSuccess: PropTypes.bool.isRequired,
  companiesHouseAddress: PropTypes.shape({
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    address_line_3: PropTypes.string,
    address_line_4: PropTypes.string,
    postcode: PropTypes.string,
  }),
  postcodeSearched: PropTypes.bool.isRequired,
  setPostcodeSearched: PropTypes.func.isRequired,
  setPostcodeIsReset: PropTypes.func.isRequired,
  manualCompanyAddressDataModel: PropTypes.shape({
    'addresses.1.address_line_1': PropTypes.string,
    'addresses.1.address_line_2': PropTypes.string,
    'addresses.1.address_line_3': PropTypes.string,
    'addresses.1.address_line_4': PropTypes.string,
    'addresses.1.postcode': PropTypes.string,
  }),
  persistedData: PropTypes.shape({
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    address_line_3: PropTypes.string,
    address_line_4: PropTypes.string,
    postcode: PropTypes.string,
  }),
};

export default RegisteredAddressSelector;
